import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Globals } from "app/globals";

@Injectable()
export class AdminGuardService implements CanActivate {

    constructor(private _Globals: Globals, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        //console.log('next', route);

        if (this._Globals.getMode() === 'Administrator') {
            this._Globals.hideChatBotForClients();
            //console.log('Logged in as admin');
            if (this._Globals.getUserType() == "manager") {
                console.log('route', route.routeConfig.path);
                if (this._Globals.managerAvailableRoutes.includes(route.routeConfig.path)) {
                    return true;
                } else {
                    this.notAllowed();
                }
            } else {
                return true;
            }            
            
        } else {
            this.notAllowed();
        }

    }

    notAllowed() {
        console.log('Not admin user');
        this.router.navigate(['/login']);
        this._Globals.deleteAllStorage();
        return false;
    }


}
